module.exports = __webpack_public_path__ + "static/media/Solgas.90ea9753.png";